/** @format */

import { Col, Card, Button } from "react-bootstrap";
import { useState } from "react";
import EducationForm from "./education-form";
import {
  useGetUserEducationsByUserID,
  useGetUserMe,
} from "../../../../../../api/queries/user.query";

const Education = () => {
  const [isOpen, setOpen] = useState(false);
  const handleToggleSection = () => {
    setOpen(!isOpen);
  };

  const { data: userData, isLoading: isLoadingUserData } = useGetUserMe({
    select: (response) => response.data.user,
  });

  const { data: educationData, isLoading: isLoadingEducationData } =
    useGetUserEducationsByUserID({
      select: (response) => response.data.user,
      enable: !!userData?.id,
      params: {
        user_id: userData?.id,
      },
    });

  return (
    <Col lg="12">
      <Card>
        <div className="w-full text-end">
          <Button
            variant="success"
            type="button"
            className="btn btn-success mt-4 fw-semibold text-uppercase d-flex align-items-center ms-auto"
            onClick={handleToggleSection}
          >
            <span className="material-symbols-outlined">add</span>
            Add New Education
          </Button>
        </div>
        <div
          style={{
            maxHeight: isOpen ? "800px" : "0",
            opacity: isOpen ? 1 : 0,
            overflow: "hidden",
            transition: "all 300ms ease-in-out",
          }}
        >
          <EducationForm />
        </div>
        <Card.Header className="d-flex justify-content-between">
          <div className="header-title">
            <h4 className="card-title">Education</h4>
          </div>
        </Card.Header>
        {isLoadingUserData ? (
          <h2>Loading...</h2>
        ) : userData && userData.educations ? ( // Correct field: 'educations'
          userData.educations.map((edu) => (
            <Card.Body key={edu.id} className="p-0">
              <ul className="iq-timeline my-0">
                <li className="d-flex">
                  {/* Timeline Dot */}
                  <div
                    className="timeline-dots bg-success me-3"
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                    }}
                  ></div>

                  {/* Content Section */}
                  <div className="w-100">
                    {/* Title and Date */}
                    <div className="d-flex align-items-center justify-content-start">
                      <h6 className="mb-1">{edu.programme}</h6>
                      <span
                        className="px-2 py-1 ms-4"
                        style={{
                          backgroundColor: "#E0F7FA", // Light blue background for date
                          borderRadius: "20px",
                          fontSize: "0.9rem",
                        }}
                      >
                        {new Date(edu.start_date).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                        })}
                        -
                        {new Date(edu.end_date).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                        })}
                      </span>
                      {/* Icons (Edit and Delete) */}
                      <div className="ms-auto">
                        <button className="btn btn-icon text-success me-2 bg-success-subtle">
                          <i className="material-symbols-outlined">edit</i>
                        </button>
                        <button className="btn btn-icon text-danger bg-danger-subtle">
                          <i className="material-symbols-outlined">delete</i>
                        </button>
                      </div>
                    </div>

                    {/* Subheading (Insititute Name and GPA) */}
                    <div className="d-flex align-items-center mb-2">
                      <a
                        href="#"
                        className="text-primary me-2 "
                        style={{
                          fontSize: "1rem",
                        }}
                      >
                        {edu.institute_string}
                      </a>
                      <span className="text-muted">| {edu.gpa} GPA</span>
                    </div>

                    {/* Description */}
                    <p className="text-muted">{edu.description}</p>
                  </div>
                </li>
              </ul>
            </Card.Body>
          ))
        ) : (
          <Card className="w-100 mt-2">
            <Card.Body>
              <ul className="iq-timeline ms-1">
                <li>
                  <div className="timeline-dots border-success"></div>
                  <div className="d-flex align-items-center justify-content-between">
                    <h6 className="mb-1">No Education Found</h6>
                    <span></span>
                  </div>
                </li>
              </ul>
            </Card.Body>
          </Card>
        )}
      </Card>
    </Col>
  );
};

export default Education;
